export default Object.freeze([
	{name: "発送先記載", value: "01"},
	{name: "QRコード", value: "02"},
])
